export default __webpack_public_path__ + "static/media/8bit16.cfef1a6a.ttf";